import { productsApi } from './products.api';

export const loadProducts = () => (dispatch, getState) => {
  const {
    appointment: {
      draft: {
        appointmentType: { id: appointmentTypeId },
      },
    },
  } = getState();

  return productsApi.fetch(appointmentTypeId).then((response) => {
    const { products } = response;

    return {
      ...response,
      products,
    };
  });
};

export const productsActions = {
  loadProducts,
};
